import { Template, BoxLayoutProperties } from '@horasys/bellplus/common/types';
import { DeviceType } from '@horasys/bellplus/common/types';
export const generateJson = (template: Template, mode: any) => {
	const jsonObj: any = {};

	jsonObj.name = template.name;
	jsonObj.duration = template.duration;
	jsonObj.width = template.deviceType.width;
	jsonObj.height = template.deviceType.height;
	jsonObj.thumbnailAssetId = template.thumbnailAssetId;
	jsonObj.deviceTypeId = template.deviceType.id;
	const assetArrayObj: Array<any> = [];
	template.assets.forEach((asset: BoxLayoutProperties) => {
		const jsonAssetObj: any = {};
		jsonAssetObj.name = asset.name;
		jsonAssetObj.type = asset.type;
		jsonAssetObj.maxSize = asset.maxSize;
		jsonAssetObj.isPrimary = asset.isPrimary;
		jsonAssetObj.width = asset.width.toString();
		jsonAssetObj.height = asset.height.toString();
		jsonAssetObj.templateTop = asset.top.toString();
		jsonAssetObj.templateLeft = asset.left.toString();
		jsonAssetObj.templateZIndex = asset.zIndex.toString();
		jsonAssetObj.action = asset.action;
		jsonAssetObj.requestId = asset.id;
		if (asset.type === 'weather') {
			const propertiesObject = {
				locationText: asset.locationText,
				weatherText: asset.weatherText,
				fontSize: asset.fontSize,
				fontColor: asset.fontColor,
				backgroundColor: asset.backgroundColor,
			};
			jsonAssetObj.properties = JSON.stringify(propertiesObject);
		}
		if (asset.type === 'datetime') {
			const propertiesObject = {
				fontSize: asset.fontSize,
				fontColor: asset.fontColor,
				backgroundColor: asset.backgroundColor,
				dateStyle: asset.dateStyle,
				innerText: asset.innerText,
			};
			jsonAssetObj.properties = JSON.stringify(propertiesObject);
		}
		if (asset.type === 'multipleImages') {
			const propertiesObject = {
				multipleImages: asset.multipleImageCount,
			};
			jsonAssetObj.properties = JSON.stringify(propertiesObject);
		}

		assetArrayObj.push(jsonAssetObj);
	});

	jsonObj.templateAssetRequest = assetArrayObj;

	return jsonObj;
};

export const getTemplateFromJson = (templateObj: any) => {
	const template: Template = {
		name: '',
		assets: [],
		templateUrl: '',
		duration: 0,
		deviceType: {} as DeviceType,
		thumbnailAssetId: 0,
		id: 0,
		standard:false
	};
	template.id = parseInt(templateObj.id);
	template.thumbnailAssetId = parseInt(templateObj.thumbnailAssetId);
	template.deviceType.id = templateObj.deviceType.id;
	template.deviceType.deviceType = templateObj.deviceType.deviceType;
	template.deviceType.width = parseInt(templateObj.width);
	template.deviceType.height = parseInt(templateObj.height);
	template.duration = parseInt(templateObj.duration);
	template.name = templateObj.name;
	template.templateUrl = templateObj.templateUrl;
	template.standard = templateObj.standard;

	const assetsObj = templateObj.assets;
	assetsObj.forEach((asset: any) => {
		const assetObj: BoxLayoutProperties = {
			name: '',
			left: 0,
			top: 0,
			width: 0,
			height: 0,
			type: 'video',
			zIndex: 0,
			isPrimary: true,
			maxSize: '',
			templateId: 0,
			status: '',
			id: 0,
			action: '',
			innerText: '',
			fontSize: 0,
			backgroundColor: '',
			fontColor: '',
			locationText: true,
			weatherText: true,
			boxShadow: '',
			isActive: false,
			overflow: '',
			dateStyle: '',
			multipleImageCount: 1,
		};
		assetObj.name = asset.name;
		assetObj.left = asset.templateLeft;
		assetObj.top = asset.templateTop;
		assetObj.width = asset.width;
		assetObj.height = asset.height;
		assetObj.zIndex = asset.templateZIndex;
		assetObj.isPrimary = asset.isPrimary;
		assetObj.maxSize = asset.maxSize;
		assetObj.type = asset.type;
		assetObj.templateId = asset.templateId;
		assetObj.status = asset.status;
		assetObj.id = asset.id;
		assetObj.action = 'UPDATE';

		template.assets.push(assetObj);
		if (assetObj.type === 'weather') {
			const propertiesObject = JSON.parse(asset.properties);
			assetObj.weatherText = propertiesObject?.weatherText;
			assetObj.locationText = propertiesObject?.locationText;
			assetObj.fontColor = propertiesObject?.fontColor;
			assetObj.fontSize = propertiesObject?.fontSize;
			assetObj.backgroundColor = propertiesObject?.backgroundColor;
		}
		if (assetObj.type === 'datetime') {
			const propertiesObject = JSON.parse(asset.properties);
			assetObj.fontSize = propertiesObject?.fontSize;
			assetObj.fontColor = propertiesObject?.fontColor;
			assetObj.backgroundColor = propertiesObject?.backgroundColor;
			assetObj.dateStyle = propertiesObject?.dateStyle;
			assetObj.innerText = propertiesObject?.innerText;
		}
		if (assetObj.type === 'multipleImages') {
			const propertiesObject = JSON.parse(asset.properties);
			assetObj.multipleImageCount = propertiesObject?.multipleImages;
		}
	});

	return template;
};
